import { AppBodyProps } from './AppBody.types'
import { AppBodyWrapper, AppBodyGrid } from './AppBody.styles'

const AppBody = ({
  gap,
  styles,
  className = '',
  children,
  ...props
}: AppBodyProps) => (
  <AppBodyWrapper
    className={`AppBody ${className}`}
    sx={styles}
    {...props}
    data-testid="app-body-wrapper">
    <AppBodyGrid gap={gap} role="grid">
      {children}
    </AppBodyGrid>
  </AppBodyWrapper>
)

export default AppBody
